var map = {
	"./1.png": 9718,
	"./2.png": 52,
	"./3.png": 6309,
	"./4.png": 4165,
	"./5.png": 3451,
	"./6.png": 2299,
	"./7.png": 5188,
	"./8.png": 8869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9390;